module.exports = __webpack_public_path__ + "img/arrow.65c66b5f.svg";